import Vue from 'vue';
import component from './index.vue';

const componentConstructor = Vue.extend(component);
const types = {
	image: 1,
	video: 2,
	doc: 3,
};

function materialLibrary(options = {}) {
	return new Promise((reslove, reject) => {
		const { type = 'image', getParams = {}, useParams = {}, usePayload = {}, multiple = 1 } = options;
		console.log(useParams);
		const dom = new componentConstructor({
			el: document.createElement('div'),
			data() {
				return {
					type: types[type],
					getParams,
					useParams,
					usePayload,
					multiple: multiple != 1,
					maxLen: multiple,
				};
			},
		});

		document.body.appendChild(dom.$el);

		dom.show(reslove, reject);
	});
}

export default {
	install(Vue) {
		if (Vue.prototype.$materialLibrary) return;
		Vue.prototype.$materialLibrary = materialLibrary;
	},
};
